import campaignApi from 'services/api/campaign'
import inviteEmailDesignApi from 'services/api/inviteEmailDesign'

import {
  mergeDesignTemplateWithCampaignBody,
  renderCustomizationBodyHtml,
  stripGlobalEmailParams
} from './campaignEmailCustomizationHelpers'
import { applyLogoDimensions } from './emailLogoHelpers'
import { renderCampaignCustomizationHtml } from './inviteEmailTemplateBodyInjector'

async function applySingleCampaign({ campaignId, designData, templateId, brandLogoUrl }) {
  const currentEmail = await campaignApi.getCampaignEmail({ campaignId }).catch(() => null)

  let mergedState = mergeDesignTemplateWithCampaignBody(
    designData,
    currentEmail?.emailParams || {},
    { brandLogoUrl }
  )
  mergedState = await applyLogoDimensions(mergedState, brandLogoUrl)
  mergedState.subsidiaryEmailTemplateId = templateId

  const html = designData?.html
    ? renderCampaignCustomizationHtml(designData.html, {
        emailTitle: mergedState.emailTitle,
        bodyHtml: renderCustomizationBodyHtml(mergedState.richtextFields?.bodyHtml),
        ctaText: mergedState.ctaText
      })
    : null

  if (!html) {
    throw new Error('Design template html was not found')
  }

  await campaignApi.updateCampaignEmail({
    campaignId,
    emailParams: stripGlobalEmailParams(mergedState),
    html,
    globalParams: designData?.globalParams || {}
  })

  return html
}

export async function applyInviteEmailDesignToCampaign({
  campaignId,
  templateId,
  brandLogoUrl,
  relatedCampaignIds = []
}) {
  const designData = await inviteEmailDesignApi.getTemplate({ templateId })

  const html = await applySingleCampaign({ campaignId, designData, templateId, brandLogoUrl })

  const applyPromises = relatedCampaignIds
    .filter(id => id && id !== campaignId)
    .map(id =>
      applySingleCampaign({ campaignId: id, designData, templateId, brandLogoUrl }).catch(() => {})
    )

  if (applyPromises.length > 0) {
    await Promise.all(applyPromises)
  }

  return {
    templateId,
    templateName: designData?.name || '',
    html
  }
}
